import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchClient } from "./client.actions";
import type {
  FetchClientResponse,
  Client,
  ClientData,
} from "features/client/client.types";

const initialState: Client = {
  data: {
    id: 0,
    title: "",
    description: "",
    description_ar: "",
    logo: "",
    light_logo: "",
    cover: "",
    name: "",
    name_ar: "",
    dashboard_type: "",
    email_otp_enabled: 0,
    sms_otp_enabled: 0,
    login_options: {
      username_password: 1,
      sso_login_enabled: 0,
    },
    urls: [],
    slug: "",
    map_config: {
      map_type: "openmap",
      map_api_key: null,
    },
  },
  isLoading: false,
  error: null,
};

const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    setClient: (state, action: PayloadAction<ClientData>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchClient.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(
      fetchClient.fulfilled,
      (state, action: PayloadAction<FetchClientResponse>) => {
        state.data = action.payload;
        state.isLoading = false;
        state.error = null;
      }
    );
    builder.addCase(fetchClient.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
    });
  },
});

export const { setClient } = clientSlice.actions;
export const clientReducer = clientSlice.reducer;
